import { IPublicClientApplication } from "@azure/msal-browser";
import { getToken } from "Components/Functions";
import { NamedDriverType } from "Components/Types"
import { api } from "./apiConfig"

export const NamedDriverAPI = {
    get: async function (instance: IPublicClientApplication, bookingId: number) {
        const apiCall = await api();
        const header = await getToken(instance);
        const response = await apiCall.request({
            url: `NamedDriver/GetNameDrivers?booking_id=${bookingId}`,
            method: "GET",
            headers: { Authorization: header }
        })
        return response.data
    },
    update: async function (instance: IPublicClientApplication, namedDriver: NamedDriverType) {
        const apiCall = await api();
        const header = await getToken(instance);
        const response = await apiCall.request({
            url: "NamedDriver/UpdateNamedDriver",
            method: "POST",
            headers: { Authorization: header },
            data: namedDriver,
        })
        return response.data
    }
}